import { Users, FileText, Globe, Shield, MessageSquare, TrendingUp } from "lucide-react";

const benefits = [
  {
    icon: Shield,
    title: "Direct Diplomatic Access",
    desc: "A rare opportunity for direct, unmediated dialogue with a sitting EU High Commissioner — not a panel, not a webinar, but a curated dialogue.",
    featured: true,
    testid: "benefit-diplomatic-access",
  },
  {
    icon: FileText,
    title: "Exclusive EU–India FTA Briefing",
    desc: "First-hand strategic insights on the India–European Union Free Trade Agreement and its implications for Gujarati and Indian businesses.",
    featured: false,
    testid: "benefit-fta-briefing",
  },
  {
    icon: Globe,
    title: "Cyprus as Your EU Gateway",
    desc: "Understand how Cyprus — as a strategic EU financial, legal, and regulatory hub — can amplify your European market access and wealth strategy.",
    featured: false,
    testid: "benefit-cyprus-gateway",
  },
  {
    icon: Users,
    title: "50 Seats. Zero Exceptions.",
    desc: "Every delegate is personally vetted. You are among Gujarat's most distinguished business owners, Chartered Accountants, and policy leaders.",
    featured: true,
    testid: "benefit-exclusive-seats",
  },
  {
    icon: TrendingUp,
    title: "Policy Clarity for Business",
    desc: "Walk away with actionable intelligence on EU regulatory priorities, compliance frameworks, and trade expansion paths relevant to your sector.",
    featured: false,
    testid: "benefit-policy-clarity",
  },
  {
    icon: MessageSquare,
    title: "Elite Peer Networking",
    desc: "A closed-door networking luncheon with Ahmedabad's most influential business minds — no junior delegates, no observers.",
    featured: false,
    testid: "benefit-networking",
  },
];

export default function WhyAttend() {
  return (
    <section id="why-attend" data-testid="why-attend-section" className="section-dark py-24 lg:py-32 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="overline-gold mb-3">Why You Should Be Here</p>
          <h2 className="font-['Cormorant_Garamond'] text-3xl lg:text-4xl text-white font-medium">
            This Is Not a Seminar.<br />
            <span className="italic text-[#D4AF37]">It Is a Dialogue.</span>
          </h2>
          <div className="gold-divider w-48 mx-auto mt-6" />
          <p className="text-[#94A3B8] text-sm font-['Outfit'] mt-5 max-w-2xl mx-auto leading-relaxed">
            In a world flooded with business events, this dialogue stands apart. Every element — the speaker, the format, the guest list — is engineered for the discerning few who shape Gujarat's economic future.
          </p>
        </div>

        {/* Benefits bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {benefits.map(({ icon: Icon, title, desc, featured, testid }) => (
            <div
              key={testid}
              data-testid={testid}
              className={`benefit-card p-7 flex flex-col gap-4 ${featured ? "border-[#D4AF37]/35 bg-[#0A1128]/80" : ""}`}
            >
              <div className={`w-11 h-11 flex items-center justify-center border ${featured ? "bg-[#D4AF37]/15 border-[#D4AF37]/40" : "bg-[#D4AF37]/8 border-[#D4AF37]/20"}`}>
                <Icon size={19} className="text-[#D4AF37]" />
              </div>
              <div>
                <h3 className="font-['Cormorant_Garamond'] text-lg text-white font-semibold mb-2">{title}</h3>
                <p className="text-[#94A3B8] text-sm font-['Outfit'] leading-relaxed">{desc}</p>
              </div>
              {featured && (
                <span className="overline-gold text-[0.58rem] mt-auto">Exclusive</span>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA banner */}
        <div className="mt-14 glass-card p-8 text-center border-[#D4AF37]/25" data-testid="why-attend-cta-banner">
          <p className="font-['Cormorant_Garamond'] text-2xl lg:text-3xl text-white font-medium mb-3">
            Your Seat at the Table of<br />
            <span className="text-[#D4AF37]">EU–India Economic Dialogue</span>
          </p>
          <p className="text-[#94A3B8] text-sm font-['Outfit'] mb-6 max-w-xl mx-auto">
            Registrations are subject to vetting. The organisers reserve the right to decline any application. Early expression of interest is strongly advised.
          </p>
          <button
            data-testid="why-attend-register-btn"
            onClick={() => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" })}
            className="btn-gold"
          >
            Express Your Interest
          </button>
        </div>
      </div>
    </section>
  );
}
